"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.actorsByCanisterId = exports.App = void 0;
const React = __importStar(require("react"));
const react_1 = require("react");
const AppThemeProvider_1 = require("src/configeek_assets/src/system/theme/AppThemeProvider");
const AppLoggedIn_1 = require("src/configeek_assets/src/components/loggedIn/AppLoggedIn");
const AppAnonymous_1 = require("src/configeek_assets/src/components/anonymous/AppAnonymous");
const PageLoaderComponent_1 = require("src/configeek_assets/src/components/common/widget/PageLoaderComponent");
const lodash_1 = __importDefault(require("lodash"));
const canisters_1 = require("src/configeek_assets/src/ic/canisters");
const CurrentPageProvider_1 = require("src/configeek_assets/src/components/common/provider/CurrentPageProvider");
const PageRedirectComponent_1 = require("src/configeek_assets/src/components/common/PageRedirectComponent");
const geekfactory_ic_js_auth_1 = require("geekfactory-ic-js-auth");
const NFIDAuthProvider_1 = require("geekfactory-ic-js-auth/lib/es5/auth/nfid/NFIDAuthProvider");
const AppAuthSwitch = (0, react_1.memo)(() => {
    const authProviderContext = (0, geekfactory_ic_js_auth_1.useAuthProviderContext)();
    if (!authProviderContext.status.isReady) {
        return React.createElement(PageLoaderComponent_1.PageLoaderComponent, null);
    }
    return authProviderContext.status.isLoggedIn ? React.createElement(AppLoggedIn_1.AppLoggedIn, null) : React.createElement(AppAnonymous_1.AppAnonymous, null);
});
const App = () => {
    return React.createElement(React.Fragment, null,
        React.createElement(AuthComponents, null,
            React.createElement(AppThemeProvider_1.AppThemeProvider, null,
                React.createElement(CurrentPageProvider_1.CurrentPageProvider, null,
                    React.createElement(AppAuthSwitch, null)))));
};
exports.App = App;
exports.actorsByCanisterId = {};
const clearActorsByCanisterId = () => {
    lodash_1.default.each(lodash_1.default.keys(exports.actorsByCanisterId), key => {
        delete exports.actorsByCanisterId[key];
    });
};
const AuthComponents = (props) => {
    const onLogout = (0, react_1.useCallback)(() => {
        PageRedirectComponent_1.LastProjectStorage.clear();
        clearActorsByCanisterId();
    }, []);
    const whitelist = lodash_1.default.cloneDeep(canisters_1.allKnownCanisterIds);
    return React.createElement(geekfactory_ic_js_auth_1.AuthSourceProvider, { storeNamespace: "configeek__" },
        React.createElement(geekfactory_ic_js_auth_1.InternetIdentityAuthProvider, { identityProviderURL: process.env.II_URL },
            React.createElement(NFIDAuthProvider_1.NFIDAuthProvider, { applicationName: "confiGeek", applicationLogo: "https://appyb-baaaa-aaaah-qc32q-cai.raw.ic0.app/favicon-64-dark_v2.svg" },
                React.createElement(geekfactory_ic_js_auth_1.PlugAuthProvider, { whitelist: whitelist, autologinTimeout: 10000 },
                    React.createElement(geekfactory_ic_js_auth_1.StoicAuthProvider, null,
                        React.createElement(geekfactory_ic_js_auth_1.InfinityWalletAuthProvider, { whitelist: whitelist },
                            React.createElement(geekfactory_ic_js_auth_1.AuthProvider, { onLogout: onLogout }, props.children)))))));
};
